'use strict';

var FlightServiceGridAggregationFactory = function FlightServiceGridAggregationFactory(DataAggregationFactory) {
  function FlightServiceGridAggregation() {
    DataAggregationFactory.call(this, 'cabin-deep', 'service-flight-analysis');
  }
  FlightServiceGridAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  FlightServiceGridAggregation.constructor = FlightServiceGridAggregation;
  FlightServiceGridAggregation.prototype.aggregate = function (data) {
    var items = [];
    for (var dataIndex = 0, dataLength = data.length; dataIndex < dataLength; dataIndex++) {
      var element = data[dataIndex].associatedServiceClasses;
      for (var associatedServiceClassesIndex = 0, associatedServiceClassesLength = element.length; associatedServiceClassesIndex < associatedServiceClassesLength; associatedServiceClassesIndex++) {
        items.push(element[associatedServiceClassesIndex].replace(/\.[^.]$/, ''));
      }
    }
    var aggregateservicedata = items.filter(function (value, index, self) {
      return self.indexOf(value) === index;
    });
    return aggregateservicedata;
  };
  return FlightServiceGridAggregation;
};
FlightServiceGridAggregationFactory.$inject = ['DataAggregationFactory'];
module.exports = FlightServiceGridAggregationFactory;